import React, {useContext, useRef} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import Reveal from "../../components/reveal/Reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  const railRef = useRef(null);

  const scrollRail = direction => {
    const rail = railRef.current;
    if (!rail) return;
    rail.scrollBy({left: direction * 380, behavior: "smooth"});
  };

  if (!workExperiences.display) {
    return null;
  }

  return (
    <div className="main experience-section" id="experience">
      <Reveal direction="up">
        <div className="experience-content reveal-stagger">
          <header className="experience-header" style={{"--i": 0}}>
            <div>
              <span className="section-eyebrow">Career</span>
              <h1 className="section-heading">Experience</h1>
              <p className="section-subtitle">
                Roles and responsibilities across my career
              </p>
            </div>
            <div className="experience-nav">
              <button
                type="button"
                className="exp-nav-btn"
                onClick={() => scrollRail(-1)}
                aria-label="Previous experience"
              >
                ‹
              </button>
              <button
                type="button"
                className="exp-nav-btn"
                onClick={() => scrollRail(1)}
                aria-label="Next experience"
              >
                ›
              </button>
            </div>
          </header>

          <div className="experience-timeline" aria-hidden="true" style={{"--i": 1}}>
            <span className="experience-timeline-line" />
            {workExperiences.experience.map((card, i) => (
              <span key={i} className="experience-timeline-dot" style={{"--i": i}}>
                <span className="experience-timeline-year">
                  {(card.date || "").split(" - ")[0] || `0${i + 1}`}
                </span>
              </span>
            ))}
          </div>

          <div className="experience-rail-wrap" style={{"--i": 2}}>
            <div ref={railRef} className="experience-cards-div">
              {workExperiences.experience.map((card, i) => (
                <div
                  key={`${card.company}-${card.role}-${i}`}
                  className="experience-slide"
                  style={{"--i": i}}
                >
                  <ExperienceCard
                    isDark={isDark}
                    index={i}
                    cardInfo={{
                      company: card.company,
                      desc: card.desc,
                      date: card.date,
                      companylogo: card.companylogo,
                      role: card.role,
                      descBullets: card.descBullets
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
